import { render, staticRenderFns } from "./UserUpdate.vue?vue&type=template&id=133f3772&scoped=true"
import script from "./UserUpdate.vue?vue&type=script&lang=js"
export * from "./UserUpdate.vue?vue&type=script&lang=js"
import style0 from "./UserUpdate.vue?vue&type=style&index=0&id=133f3772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f3772",
  null
  
)

export default component.exports